import { NgModule } from '@angular/core';
import {NullPipe} from './null.pipe';
import { SafePipe } from './safe.pipe';

@NgModule({
  declarations: [
    /* declare it once, here */
   NullPipe,
    SafePipe
  ],
    exports: [
        /* then export it */
        NullPipe,
        SafePipe
    ]
})
export class SharedModule { }
